import { inject, Injectable } from "@angular/core";
import { StateService } from "./state.service";

@Injectable({
  providedIn: 'root',
})
export class PostMessageService {
    private stateService = inject(StateService)

    sendMessage(message: any, action: WindowPostMessageAction) {
        const data = { message, action };
        window.parent.postMessage(data, `${this.stateService.parentUrl}`);
    }

    isSameHostAsParent(url: string): boolean {
        try {
            const parentUrl = this.stateService.parentUrl;
            if (!parentUrl) {
                return false;
            }
            return new URL(url, parentUrl).hostname === new URL(parentUrl).hostname;
        } catch {
            return false;
        }
    }
}

export enum WindowPostMessageAction {
    OPEN_LINK = "OPEN_LINK",
    SET_SESSION_ID = "SET_SESSION_ID"
}
